import type { FC } from 'react';

import BuyableRecipeFlyIn from '../BuyableRecipeFlyIn/BuyableRecipeFlyIn';
import type { BuyableRecipeFlyInViews } from '../BuyableRecipeFlyIn/BuyableRecipeFlyIn.types';
import BuyableRecipeButton from '../molecules/BuyableRecipeButton';

interface RecipeModalButtonProps {
    recipeId: string;
    recipeName: string;
    recipeType: 'recipe' | 'foodbox';
    viewType: BuyableRecipeFlyInViews;
    allowRecipePageRedirect: boolean;
    defaultPortions: number;
    onBuyClick?: (e: React.SyntheticEvent) => void;
    onRemoveClick?: (e: React.SyntheticEvent) => void;
    buyText?: string;
    removeText?: string;
    buttonSize: 'default' | 'large';
    buttonFullWidth: boolean;
    analyticsListName: string;
    isOpen: boolean;
    close: () => void;
}

const RecipeButtonWithFlyIn: FC<React.PropsWithChildren<RecipeModalButtonProps>> = ({
    viewType,
    allowRecipePageRedirect,
    recipeId,
    recipeName,
    recipeType,
    defaultPortions,
    onBuyClick,
    onRemoveClick,
    buyText,
    removeText,
    buttonSize,
    analyticsListName,
    isOpen,
    close,
    buttonFullWidth,
}) => {
    return (
        // do not bubble events to parent elements like teasers
        <div onClick={(e) => e.stopPropagation()}>
            <BuyableRecipeFlyIn
                recipeId={recipeId}
                recipeName={recipeName}
                recipeType={recipeType}
                analyticsListName={analyticsListName}
                defaultPortions={defaultPortions}
                viewType={viewType}
                allowRecipePageRedirect={allowRecipePageRedirect}
                isOpen={isOpen}
                onClose={close}
                renderTrigger={(ref) => (
                    <BuyableRecipeButton
                        buyButtonRef={ref}
                        recipeId={recipeId}
                        recipeName={recipeName}
                        onRemoveClick={onRemoveClick}
                        onBuyClick={onBuyClick}
                        buttonSize={buttonSize}
                        buyText={buyText}
                        removeText={removeText}
                        buttonFullWidth={buttonFullWidth}
                    />
                )}
            />
        </div>
    );
};

export default RecipeButtonWithFlyIn;
